// Array of field configurations

export const breadcrumbItems = [
    { label: "Exclusive", link: "/auth/exclusive" },
];
